import axios from '../axios'
import { logError } from 'shared'
import { getHeadersWithJwtToken } from '../../../auth/utils/auth-util'
import appConfig from 'app.config'
export interface SspLinkData {
	partitionKey: string
	rowKey: string
	link: string
}

async function getSspTermsService() {
	const response = await axios
		.get<SspLinkData[]>(
			`${appConfig.customerDataBaseUrl}/api/CustomerService/ssp/agrementlinks`,
			await getHeadersWithJwtToken()
		)
		.then((result) => {
			if (result !== undefined) {
				return result.data as SspLinkData[]
			}
		})
		.catch((err) => {
			logError(err)
			if (err.response?.status === 404) {
				throw new Error('No documents found in database')
			} else {
				throw new Error(err.response.message)
			}
		})
	return response as SspLinkData[]
}
export default getSspTermsService
